import * as S from './OrganizationsList.styled';
import { useSelector } from 'react-redux';
import Table from './components/Table';
import { useAppDispatch } from 'hooks/useStore';
import { IsOwnerSelector } from 'features/User/UserSlice';
import {
  OrganizationsListItemsSelector,
  removeOrganization,
} from './OrganizationsListSlice';
import { openEditOrganizationModal } from 'features/EditOrganizationModal/EditOrganizationModalSlice';
import { JSX } from 'react/jsx-runtime';

const LotsList = (): JSX.Element => {
  const dispatch = useAppDispatch();

  // Список застройщиков
  const organizations = useSelector(OrganizationsListItemsSelector);

  // Владелец приложения
  const isOwner = useSelector(IsOwnerSelector);

  // Открытие модалки с карточкой сервис. сентра для редактирования
  const onOpenOldOrganizationModal = (organizationId: number) =>
    dispatch(openEditOrganizationModal(organizationId));

  // Открытие модалки с карточкой сервис. сентра для редактирования
  const onRemoveOrganization = (organizationId: number) =>
    dispatch(removeOrganization(organizationId));

  return (
    <S.Wrap>
      <Table
        items={organizations}
        isDisabled={!isOwner}
        onEdit={onOpenOldOrganizationModal}
        onRemove={onRemoveOrganization}
      />
    </S.Wrap>
  );
};

export default LotsList;
